// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
			//suggestionMode: 'test',
			//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	InstantSearchMobile.prototype.afterShowSearchBoxMobile = function(searchBoxId) {
		if (!searchBoxId) searchBoxId = this.searchBoxId;
		// Hide debut's search bar on mobile, and show our search bar instead
		if(jQ('.js-drawer-close').length > 0){
			setTimeout(function() {
				jQ('.js-drawer-close').trigger('click');
			});
		}
	};

	SearchInput.prototype.customizeInstantSearch= function() {
		// Hide debut's search suggestion
		if (jQ('.predictive-search-wrapper').length > 0){
				jQ('.predictive-search-wrapper').hide();
		}
	};

	function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
		/* console.log('closeSuggestionMobile'); */
		jQ(searchBoxId).autocomplete('close');
		jQ('.' + Class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
		// Remove search box
		var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
		if (isCloseSearchBox) jQ('.boost-pfs-search-suggestion-mobile-top-panel,.boost-pfs-search-suggestion-mobile-overlay').hide();
		// Update current term for all search boxes
		setValueAllSearchBoxes();
		// Add back tabindex=-1
		jQ('.boost-pfs-search-no-tabindex').attr('tabindex', -1);
		// Return scrolling of body
		if(jQ('body').hasClass(Class.searchSuggestionMobileOpen)){    
			jQ('body').removeClass(Class.searchSuggestionMobileOpen);
		}
		BoostPFS.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);
	
		// Close search theme debut
		if(jQ('.js-drawer-close').length > 1){
			jQ('.js-drawer-close').trigger('click');
		}
	}

      SearchInput.prototype._onSubmit = function (event, redirect) { //Update whole function #43301
		if (typeof redirect == 'undefined') {
			redirect = this.isChangePage;
		}
		this.isChangePage = false;

		if (!redirect) {
			// Stop all default submit events
			event.stopImmediatePropagation();
			event.stopPropagation();
			event.preventDefault();
			// Fix case can not get current value from input
			Globals.currentTerm = Utils.stripHtml(this.$element.val());
			if (!Globals.currentTerm && event && event.target) {
				Globals.searchTerm = Utils.stripHtml(event.target.value);
			}
			var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();

			// if API returned results or the suggestionCache has the search term, submit search
			// else: add the data-search-submit attribute to the search input box, wait for the api returns the result,
			// then remove this attribute in the checkForSearchRedirect function
			var query = Utils.unescape(Globals.currentTerm);
			query = query.trim().replace(/\s+/g, ' ');
			var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(query);
			// Set recent searches
			InstantSearchOnclick.setOnClickRecentSearches(query);
			// If the API returned results, either redirect or perform submit

			if (isApiReturnedResult, Globals.currentTerm) {
				if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
					Utils.setWindowLocation(redirectUrl);
				} else {
					this.isChangePage = true;
					this.$searchForm[0].submit();
				}
			} else if (Globals.currentTerm) {
				// If the API hasn't returned results, set data-search-submit on the search input and wait
				this.$element.data('search-submit', true);
			} else {
				this.isChangePage = true;
				this.$searchForm[0].submit();
			}
		}
	}
})();